import { t } from 'i18next';

export enum TlsServerVersion {
  TLS13 = 'TLS13',
  TLS12 = 'TLS12',
  TLS11 = 'TLS11',
  TLS10 = 'TLS10',
  SSL30 = 'SSL30',
  UNKNOWN = 'UNKNOWN',
}

export const formatTlsServerVersion = (value: TlsServerVersion | null) => {
  switch (value) {
    case TlsServerVersion.TLS13:
      return 'TLS 1.3';
    case TlsServerVersion.TLS12:
      return 'TLS 1.2';
    case TlsServerVersion.TLS11:
      return 'TLS 1.1';
    case TlsServerVersion.TLS10:
      return 'TLS 1.0';
    case TlsServerVersion.SSL30:
      return 'SSL 3.0';
    case TlsServerVersion.UNKNOWN:
      return t('tlsVersion.unknown');
    default:
      return t('handshakes.emptyCol');
  }
};

export const formatTlsServerVersionDecimal = (value: TlsServerVersion) => {
  switch (value) {
    case TlsServerVersion.TLS13:
      return '772';
    case TlsServerVersion.TLS12:
      return '771';
    case TlsServerVersion.TLS11:
      return '770';
    case TlsServerVersion.TLS10:
      return '769';
    case TlsServerVersion.SSL30:
      return '768';
    default:
      return value;
  }
};
